import { render } from "./CheckboxList.vue?vue&type=template&id=62f1d8b8&lang=pug"
import script from "./CheckboxList.vue?vue&type=script&lang=ts"
export * from "./CheckboxList.vue?vue&type=script&lang=ts"
script.render = render

export default script